import {
  CompanyReportState,
  CompanyReportTypes,
  ImportationsReportTypes,
} from './types';

const INITIAL_STATE: CompanyReportState = {
  companyReportList: [],
  importationsReport: [],
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Company
const listCompanyReportRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyReportList: INITIAL_STATE.companyReportList,
});

const listCompanyReportSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyReportList: action.payload.companyReportList,
  totalCount: action.payload.totalCount,
});

const listCompanyReportFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyReportList: INITIAL_STATE.companyReportList,
});

// Importations Company
const importaionsReportRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  importationsReport: INITIAL_STATE.importationsReport,
});

const importaionsReportSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  importationsReport: action.payload.importationsReport,
  totalCount: action.payload.totalCount,
});

const importaionsReportFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  importationsReport: INITIAL_STATE.importationsReport,
});

const reducer = createReducer(INITIAL_STATE, {
  [CompanyReportTypes.LIST_COMPANY_REPORT_REQUEST]: listCompanyReportRequest,
  [CompanyReportTypes.LIST_COMPANY_REPORT_SUCCESS]: listCompanyReportSuccess,
  [CompanyReportTypes.LIST_COMPANY_REPORT_FAILURE]: listCompanyReportFailure,
  [ImportationsReportTypes.IMPORTATIONS_REPORT_REQUEST]: importaionsReportRequest,
  [ImportationsReportTypes.IMPORTATIONS_REPORT_SUCCESS]: importaionsReportSuccess,
  [ImportationsReportTypes.IMPORTATIONS_REPORT_FAILURE]: importaionsReportFailure,
});

export default reducer;
